export PictureForm from './PictureForm';



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/common/index.js